import IWall from 'components/interfaces/IWall';

import {
  ALU_2K_GLAZY,
  SLIDY_30,
  SLIDY_36,
  ALU_GLAZY,
  WOODY_ELEMENTS,
  WOODY_GLAZY,
  WOODY_PLANE,
  WOODY_ALU,
  WOODY_2K_ELEMENTS,
  GLAZY_DOUBLE,
  WOODY_2K_GLAZY,
  WOODY_2K_ALU,
} from './glazingWallTypes';

export const is2kAluGlazy = (wall: IWall): boolean =>
  wall.glazingWallType === ALU_2K_GLAZY;

export const isAluGlazy = (wall: IWall): boolean =>
  wall.glazingWallType === ALU_GLAZY;

export const isSlidy30 = (wall: IWall): boolean =>
  wall.glazingWallType === SLIDY_30;

export const isSlidy36 = (wall: IWall): boolean =>
  wall.glazingWallType === SLIDY_36;

export const isWoodyTypeWall = (wall: IWall): boolean =>
  wall.glazingWallType.includes('woody');

export const isWoodyTypeWallByType = (glazingType: string): boolean =>
  glazingType.includes('woody');

export const is2kTypeWall = (wall: IWall): boolean =>
  wall.glazingWallType.includes('2k');

export const isWoodyTypeWallWithout42and43 = (wall: IWall): boolean =>
  wall.glazingWallType === WOODY_ELEMENTS ||
  wall.glazingWallType === WOODY_PLANE ||
  wall.glazingWallType === WOODY_GLAZY ||
  wall.glazingWallType === WOODY_ALU;

export const isWoodyTypeWallWith42and43 = (wall: IWall): boolean =>
  wall.glazingWallType === GLAZY_DOUBLE ||
  wall.glazingWallType === WOODY_2K_GLAZY ||
  wall.glazingWallType === WOODY_2K_ALU ||
  wall.glazingWallType === WOODY_2K_ELEMENTS;
